@if (data && data.ticket) {
  <mat-dialog-content class="fullscreen-dialog">
    <mat-toolbar class="fullscreen-toolbar" color="primary">
      Job Information for {{ data.ticket.visit.job.externalJobReference }}
    </mat-toolbar>
    @if (urmEnabled) {
      <div>
        Property Info
        <urm-property-info
        [externalPropertyReference]="data.ticket.visit.job.externalPropertyReference"></urm-property-info>
      </div>
    }
  </mat-dialog-content>
}
